export function bonusInfoForGame(game, bonusMap = {}) {
  if (!game) return null;
  const live = bonusMap?.[game.id];
  const percent = Number(
    live?.current_bonus_percent ??
    game.regular_deposit_bonus_percent ??
    game.first_deposit_bonus_percent ??
    0
  );
  if (!Number.isFinite(percent) || percent <= 0) return null;
  return {
    percent,
    label: `${percent}% bonus`,
    isFirstCashLoad: Boolean(live?.is_first_cash_load),
    firstPercent: Number(live?.first_deposit_bonus_percent ?? game.first_deposit_bonus_percent ?? percent),
    regularPercent: Number(live?.regular_deposit_bonus_percent ?? game.regular_deposit_bonus_percent ?? percent),
  };
}

export function BonusBadge({ game, bonuses, className = "" }) {
  const info = bonusInfoForGame(game, bonuses);
  if (!info) return null;
  return (
    <span className={`inline-flex items-center rounded-full border border-sky-200 bg-sky-50 px-3 py-1 text-xs font-black text-[#2f78b7] shadow-sm ${className}`}>
      {info.label}
    </span>
  );
}
